export enum ResultadosEventsEnum {
  CarbonoRegistrado = 'carbono-registrado',
  UmidadeBalancaRegistrado = 'umidade-balanca-registrado',
  FrxRegistrado = 'frx-registrado',
  FrxQualitativoRegistrado = 'frx-qualitativo-registrado',
  CalcinacaoRegistrado = 'calcinacao-registrado',
  UmidadeEstufaRegistrado = 'umidade-estufa-registrado',
  GravimetriaRegistrado = 'gravimetria-registrado',
  IcpRegistrado = 'icp-registrado',
  IcpCobreRegistrado = 'icp-cobre-registrado',
}
export enum StatusEnsaioEnum {
  PENDENTE = 'PENDENTE',
  EM_ANDAMENTO = 'EM_ANDAMENTO',
  FINALIZADO = 'FINALIZADO',
}
export enum EnsaiosEventsEnum {
  EnsaioExtraRotinaReanaliseCriado = 'ensaio-extra-rotina-reanalise-criado',
  EnsaioCancelado = 'ensaio-cancelado',
}

export enum TipoEnsaioEnum {
  ROTINA = 'Rotina',
  REANALISE = 'Reanálise',
  EXTRA_ROTINA = 'Extra-rotina',
}
